import {
    ATENCION_REQUEST,
    ATENCION_SUCCESS,
    ATENCION_FAILURE,
    SET_ATENCION_ACTIVA,
    CLEAR_ATENCION_ACTIVA,
    UPDATE_ATENCION_ITEMS,
    SET_SESIONES_ATENCION,
    UPDATE_SESION_LOCAL,
} from "./atencionesTypes";
import {
    iniciarAtencion as iniciarAtencionService,
    // finalizarAtencion as finalizarAtencionService, // Deprecated in favor of transactional
    finalizarAtencionCompleta,
    fetchAtencionActivaByUsuario,
    updateAtencionItems as updateAtencionItemsService,
} from "../../services/firebase/atenciones";
import {
    crearSesion,
    eliminarSesion,
    fetchSesionesByAtencion
} from "../../services/firebase/sesiones";
import { getPaciente } from "../../services/firebase/pacientes";
import { loadPatientData, setPaciente } from "../paciente/pacienteActions";
import { setPacienteSesion } from "../sesion/sesionActions";
import { iniciarPrestacionTrx } from "../prestation/prestationActions";
import moment from "moment-timezone";

// Removed fetchPrestacionesSesion import as we will handle it in atencion

export const atencionRequest = () => ({ type: ATENCION_REQUEST });
export const atencionSuccess = () => ({ type: ATENCION_SUCCESS });
export const atencionFailure = (error) => ({
    type: ATENCION_FAILURE,
    payload: error,
});

export const setAtencionActiva = (atencion) => ({
    type: SET_ATENCION_ACTIVA,
    payload: atencion,
});

export const clearAtencionActiva = () => ({ type: CLEAR_ATENCION_ACTIVA });

export const setSesionesAtencion = (sesiones) => ({
    type: SET_SESIONES_ATENCION,
    payload: sesiones
});

export const updateSesionLocal = (sesionId, data) => ({
    type: UPDATE_SESION_LOCAL,
    payload: { sesionId, data }
});

export const startAtencionActiva = (atencionData) => {
    return async (dispatch) => {
        dispatch(atencionRequest());
        try {
            const atencion = await iniciarAtencionService(atencionData);
            const sesiones = await fetchSesionesByAtencion(atencion.pacienteId, atencion.id, atencion.empresaId);
            // Ensure full patient data (prestations, etc) is loaded
            const paciente = await getPaciente(atencion.pacienteId, atencion.empresaId);
            if (paciente) {
                await dispatch(loadPatientData(paciente, moment().format("YYYY-MM-DD"), atencion.id));
            }
            dispatch(setAtencionActiva(atencion));
            dispatch(setSesionesAtencion(sesiones));
            dispatch(atencionSuccess());
            return atencion;
        } catch (error) {
            dispatch(atencionFailure(error.message));
            throw error;
        }
    };
};

export const closeAtencionActiva = (atencionId, pacienteId, especialistaEmail) => {
    return async (dispatch, getState) => {
        dispatch(atencionRequest());
        try {
            const state = getState();
            const atencionActiva = state.atenciones.atencionActiva;
            const empresaId = atencionActiva.empresaId;
            const allPrestaciones = state.prestaciones.items;
            const cuenta = state.cuenta;

            const sessionItemsIds = atencionActiva?.items || [];

            // Filter prestaciones that are pending and belong to this session
            const prestacionesToActivate = allPrestaciones.filter(p =>
                sessionItemsIds.includes(p.id) && p.estado === 'PENDIENTE'
            );

            const finalStatus = (sessionItemsIds.length === 0) ? "ANULADA" : "CERRADA";

            if (!cuenta || !cuenta.id) {
                throw new Error("No hay cuenta activa para procesar los cargos.");
            }

            // Execute single transaction
            const result = await finalizarAtencionCompleta({
                atencionId,
                pacienteId,
                empresaId,
                especialistaId: especialistaEmail,
                prestacionesToActivate,
                finalStatus,
                cuentaId: cuenta.id
            });

            // Update local state based on transaction result
            // 1. Update activated prestations
            if (result.updatedPrestaciones && result.updatedPrestaciones.length > 0) {
                result.updatedPrestaciones.forEach(p => {
                    // We can reuse the action or dispatch a bulk update if available.
                    // For now, updating individually or triggering a refresh would work.
                    // Since we don't have a BULK_UPDATE_PRESTATIONS, we can update them in array one by one 
                    // or assume the component will refresh data. 
                    // Let's use the existing helper to update Redux Store
                    dispatch({ type: "UPDATE_PRESTATION_IN_ARRAY", payload: p });
                });
            }

            // 2. Update Account if needed
            if (result.newCuentaData) {
                dispatch({ type: "SET_CUENTA", payload: result.newCuentaData });
            }

            dispatch(clearAtencionActiva());
            dispatch(atencionSuccess());
        } catch (error) {
            console.error("Error closing attention:", error);
            dispatch(atencionFailure(error.message));
            throw error;
        }
    };
};

export const checkAtencionActiva = (usuarioId) => {
    return async (dispatch) => {
        dispatch(atencionRequest());
        try {

            const atencion = await fetchAtencionActivaByUsuario(usuarioId);

            if (atencion) {
                const sesiones = await fetchSesionesByAtencion(atencion.pacienteId, atencion.id, atencion.empresaId);
                const paciente = await getPaciente(atencion.pacienteId, atencion.empresaId);
                if (paciente) {
                    await dispatch(loadPatientData(paciente, moment().format("YYYY-MM-DD"), atencion.id));
                }
                dispatch(setAtencionActiva(atencion));
                dispatch(setSesionesAtencion(sesiones));
            } else {
                dispatch(clearAtencionActiva());
                dispatch(setPacienteSesion(false));
            }
            dispatch(atencionSuccess());
        } catch (error) {
            dispatch(atencionFailure(error.message));
        }
    };
};

export const updateActiveAtencionItems = (pacienteId, atencionId, empresaId, items) => {
    return async (dispatch) => {
        dispatch(atencionRequest());
        try {
            await updateAtencionItemsService(pacienteId, atencionId, empresaId, items);
            dispatch({ type: UPDATE_ATENCION_ITEMS, payload: items });
            dispatch(atencionSuccess());
        } catch (error) {
            dispatch(atencionFailure(error.message));
            throw error;
        }
    };
};

export const linkTreatmentToAtencion = (pacienteId, atencionId, prestacionId, especialistaEmail) => {
    return async (dispatch, getState) => {
        dispatch(atencionRequest());
        try {
            const { atencionActiva } = getState().atenciones;
            const empresaId = atencionActiva.empresaId;
            const currentItems = atencionActiva?.items || [];

            if (!currentItems.includes(prestacionId)) {
                const updatedItems = [...currentItems, prestacionId];

                // 1. Create Bridge Session
                await crearSesion(pacienteId, empresaId, {
                    atencionId,
                    prestacionId,
                    especialistaId: especialistaEmail,
                    nota: ""
                });

                // 2. Update Atencion Items List
                await updateAtencionItemsService(pacienteId, atencionId, empresaId, updatedItems);

                // 3. Refresh State
                const newSesiones = await fetchSesionesByAtencion(pacienteId, atencionId, empresaId);
                dispatch(setSesionesAtencion(newSesiones));
                dispatch({ type: UPDATE_ATENCION_ITEMS, payload: updatedItems });
            }

            dispatch(atencionSuccess());
        } catch (error) {
            dispatch(atencionFailure(error.message));
            throw error;
        }
    };
};

export const unlinkTreatmentFromAtencion = (pacienteId, atencionId, prestacionId) => {
    return async (dispatch, getState) => {
        dispatch(atencionRequest());
        try {
            const { atencionActiva } = getState().atenciones;
            const empresaId = atencionActiva.empresaId;
            const currentItems = atencionActiva?.items || [];
            const updatedItems = currentItems.filter(id => id !== prestacionId);

            // 1. Delete Bridge Sessions
            await eliminarSesion(pacienteId, atencionId, prestacionId, empresaId);

            // 2. Update Atencion Items List
            await updateAtencionItemsService(pacienteId, atencionId, empresaId, updatedItems);

            // 3. Refresh State
            const newSesiones = await fetchSesionesByAtencion(pacienteId, atencionId, empresaId);
            dispatch(setSesionesAtencion(newSesiones));
            dispatch({ type: UPDATE_ATENCION_ITEMS, payload: updatedItems });

            dispatch(atencionSuccess());
        } catch (error) {
            dispatch(atencionFailure(error.message));
            throw error;
        }
    };
};

export const linkMultipleTreatmentsToAtencion = (pacienteId, atencionId, prestacionIds, especialistaEmail) => {
    return async (dispatch, getState) => {
        dispatch(atencionRequest());
        try {
            const { atencionActiva } = getState().atenciones;
            const empresaId = atencionActiva.empresaId;
            const currentItems = atencionActiva?.items || [];
            let updatedItems = [...currentItems];
            const newItems = [];

            // Identificar nuevos
            prestacionIds.forEach(id => {
                if (!currentItems.includes(id)) {
                    updatedItems.push(id);
                    newItems.push(id);
                }
            });

            if (newItems.length > 0) {
                // 1. Create Bridge Sessions for ALL new items in parallel
                const sessionPromises = newItems.map(pId =>
                    crearSesion(pacienteId, empresaId, {
                        atencionId,
                        prestacionId: pId,
                        especialistaId: especialistaEmail,
                        nota: ""
                    })
                );
                await Promise.all(sessionPromises);

                // 2. Update Atencion Items List ONCE
                await updateAtencionItemsService(pacienteId, atencionId, empresaId, updatedItems);

                // 3. Refresh State
                const newSesiones = await fetchSesionesByAtencion(pacienteId, atencionId, empresaId);
                dispatch(setSesionesAtencion(newSesiones));
                dispatch({ type: UPDATE_ATENCION_ITEMS, payload: updatedItems });
            }

            dispatch(atencionSuccess());
        } catch (error) {
            console.error("Error linking treatments:", error);
            dispatch(atencionFailure(error.message));
            throw error;
        }
    };
};
